import { render, staticRenderFns } from "./DevicePropertiesList.vue?vue&type=template&id=87c98208&scoped=true&"
import script from "./DevicePropertiesList.vue?vue&type=script&lang=ts&"
export * from "./DevicePropertiesList.vue?vue&type=script&lang=ts&"
import style0 from "./DevicePropertiesList.vue?vue&type=style&index=0&id=87c98208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c98208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
